import Cr from 'crypto-js'
import { ENCRIPTION_SECRET } from '@/config'

class Crypto {
  static encodeObj (data) {
    return Cr.AES.encrypt(JSON.stringify(data), ENCRIPTION_SECRET).toString()
  }

  static decodeObj (ciphertext) {
    const bytes = Cr.AES.decrypt(ciphertext, ENCRIPTION_SECRET)
    return JSON.parse(bytes.toString(Cr.enc.Utf8))
  }

  static decodeBase64Obj (ciphertext) {
    const tmp = Cr.enc.Base64.parse(ciphertext)
    return JSON.parse(Cr.enc.Utf8.stringify(tmp))
  }
}

export { Crypto }
